/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * AI Enablement Platform
 * Enterprise AI enablement analysis and recommendations platform
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgentConfigResponse,
  AgentConfigUpdateRequest,
  AgentInfo,
  FlowInfo,
  HTTPValidationError
} from '.././models';

import { customInstance } from '../../services/api-client';




/**
 * List all available CrewAI flows.

Returns basic information about each flow including the number of agents.
 * @summary List all flows
 */
export const listFlowsV1AgentsFlowsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<FlowInfo[]>(
      {url: `/v1/agents/flows`, method: 'GET', signal
    },
      );
    }
  



export const getListFlowsV1AgentsFlowsGetQueryKey = () => {
    return [
    `/v1/agents/flows`
    ] as const;
    }

    
export const getListFlowsV1AgentsFlowsGetQueryOptions = <TData = Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListFlowsV1AgentsFlowsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>> = ({ signal }) => listFlowsV1AgentsFlowsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListFlowsV1AgentsFlowsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>>
export type ListFlowsV1AgentsFlowsGetQueryError = unknown


export function useListFlowsV1AgentsFlowsGet<TData = Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>,
          TError,
          Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListFlowsV1AgentsFlowsGet<TData = Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>,
          TError,
          Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListFlowsV1AgentsFlowsGet<TData = Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all flows
 */

export function useListFlowsV1AgentsFlowsGet<TData = Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listFlowsV1AgentsFlowsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListFlowsV1AgentsFlowsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List all agents in a specific flow.

Returns current configuration for each agent including the model and provider being used.
 * @summary List agents in a flow
 */
export const listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet = (
    flowId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AgentInfo[]>(
      {url: `/v1/agents/flows/${flowId}/agents`, method: 'GET', signal
    },
      );
    }
  



export const getListAgentsInFlowV1AgentsFlowsFlowIdAgentsGetQueryKey = (flowId?: string,) => {
    return [
    `/v1/agents/flows/${flowId}/agents`
    ] as const;
    }

    
export const getListAgentsInFlowV1AgentsFlowsFlowIdAgentsGetQueryOptions = <TData = Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError = HTTPValidationError>(flowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAgentsInFlowV1AgentsFlowsFlowIdAgentsGetQueryKey(flowId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>> = ({ signal }) => listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet(flowId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(flowId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAgentsInFlowV1AgentsFlowsFlowIdAgentsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>>
export type ListAgentsInFlowV1AgentsFlowsFlowIdAgentsGetQueryError = HTTPValidationError


export function useListAgentsInFlowV1AgentsFlowsFlowIdAgentsGet<TData = Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError = HTTPValidationError>(
 flowId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>,
          TError,
          Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAgentsInFlowV1AgentsFlowsFlowIdAgentsGet<TData = Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError = HTTPValidationError>(
 flowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>,
          TError,
          Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAgentsInFlowV1AgentsFlowsFlowIdAgentsGet<TData = Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError = HTTPValidationError>(
 flowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List agents in a flow
 */

export function useListAgentsInFlowV1AgentsFlowsFlowIdAgentsGet<TData = Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError = HTTPValidationError>(
 flowId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAgentsInFlowV1AgentsFlowsFlowIdAgentsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAgentsInFlowV1AgentsFlowsFlowIdAgentsGetQueryOptions(flowId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * List all agent configuration overrides for the current customer.

Only returns agents that have database overrides (not code defaults).
 * @summary List all agent configuration overrides
 */
export const listAllConfigurationsV1AgentsConfigurationsGet = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<AgentConfigResponse[]>(
      {url: `/v1/agents/configurations`, method: 'GET', signal
    },
      );
    }
  



export const getListAllConfigurationsV1AgentsConfigurationsGetQueryKey = () => {
    return [
    `/v1/agents/configurations`
    ] as const;
    }

    
export const getListAllConfigurationsV1AgentsConfigurationsGetQueryOptions = <TData = Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListAllConfigurationsV1AgentsConfigurationsGetQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>> = ({ signal }) => listAllConfigurationsV1AgentsConfigurationsGet(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ListAllConfigurationsV1AgentsConfigurationsGetQueryResult = NonNullable<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>>
export type ListAllConfigurationsV1AgentsConfigurationsGetQueryError = unknown


export function useListAllConfigurationsV1AgentsConfigurationsGet<TData = Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>,
          TError,
          Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAllConfigurationsV1AgentsConfigurationsGet<TData = Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>,
          TError,
          Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useListAllConfigurationsV1AgentsConfigurationsGet<TData = Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List all agent configuration overrides
 */

export function useListAllConfigurationsV1AgentsConfigurationsGet<TData = Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listAllConfigurationsV1AgentsConfigurationsGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getListAllConfigurationsV1AgentsConfigurationsGetQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Get current agent configuration (merged: database overrides + code defaults).

This returns the complete configuration that will be used at runtime.
 * @summary Get agent configuration
 */
export const getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet = (
    flowId: string,
    agentId: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<AgentConfigResponse>(
      {url: `/v1/agents/configurations/${flowId}/${agentId}`, method: 'GET', signal
    },
      );
    }
  



export const getGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGetQueryKey = (flowId?: string,
    agentId?: string,) => {
    return [
    `/v1/agents/configurations/${flowId}/${agentId}`
    ] as const;
    }

    
export const getGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGetQueryOptions = <TData = Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError = HTTPValidationError>(flowId: string,
    agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGetQueryKey(flowId,agentId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>> = ({ signal }) => getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet(flowId,agentId, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(flowId && agentId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>>
export type GetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGetQueryError = HTTPValidationError


export function useGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet<TData = Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError = HTTPValidationError>(
 flowId: string,
    agentId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>,
          TError,
          Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet<TData = Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError = HTTPValidationError>(
 flowId: string,
    agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>,
          TError,
          Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet<TData = Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError = HTTPValidationError>(
 flowId: string,
    agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get agent configuration
 */

export function useGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet<TData = Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError = HTTPValidationError>(
 flowId: string,
    agentId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGet>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdGetQueryOptions(flowId,agentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Update agent configuration.

Changes take effect immediately on next execution. Cache is automatically invalidated.

Provider resolution:
- If provider_config_id is specified, uses that provider
- If provider_name is specified, looks up provider by name
- Otherwise, auto-selects provider based on model and priority
 * @summary Update agent configuration
 */
export const updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut = (
    flowId: string,
    agentId: string,
    agentConfigUpdateRequest: AgentConfigUpdateRequest,
 ) => {
      
      
      return customInstance<AgentConfigResponse>(
      {url: `/v1/agents/configurations/${flowId}/${agentId}`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: agentConfigUpdateRequest
    },
      );
    }
  


export const getUpdateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPutMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut>>, TError,{flowId: string;agentId: string;data: AgentConfigUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut>>, TError,{flowId: string;agentId: string;data: AgentConfigUpdateRequest}, TContext> => {

const mutationKey = ['updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut>>, {flowId: string;agentId: string;data: AgentConfigUpdateRequest}> = (props) => {
          const {flowId,agentId,data} = props ?? {};

          return  updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut(flowId,agentId,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPutMutationResult = NonNullable<Awaited<ReturnType<typeof updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut>>>
    export type UpdateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPutMutationBody = AgentConfigUpdateRequest
    export type UpdateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPutMutationError = HTTPValidationError

    /**
 * @summary Update agent configuration
 */
export const useUpdateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut>>, TError,{flowId: string;agentId: string;data: AgentConfigUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPut>>,
        TError,
        {flowId: string;agentId: string;data: AgentConfigUpdateRequest},
        TContext
      > => {

      const mutationOptions = getUpdateAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdPutMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Reset agent configuration to code defaults.

Deletes any custom configuration, causing the agent to use default settings.
 * @summary Reset agent configuration
 */
export const resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete = (
    flowId: string,
    agentId: string,
 ) => {
      
      
      return customInstance<void>(
      {url: `/v1/agents/configurations/${flowId}/${agentId}`, method: 'DELETE'
    },
      );
    }
  


export const getResetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDeleteMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete>>, TError,{flowId: string;agentId: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete>>, TError,{flowId: string;agentId: string}, TContext> => {

const mutationKey = ['resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete>>, {flowId: string;agentId: string}> = (props) => {
          const {flowId,agentId} = props ?? {};

          return  resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete(flowId,agentId,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ResetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDeleteMutationResult = NonNullable<Awaited<ReturnType<typeof resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete>>>
    
    export type ResetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDeleteMutationError = HTTPValidationError

    /**
 * @summary Reset agent configuration
 */
export const useResetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete>>, TError,{flowId: string;agentId: string}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof resetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDelete>>,
        TError,
        {flowId: string;agentId: string},
        TContext
      > => {

      const mutationOptions = getResetAgentConfigurationV1AgentsConfigurationsFlowIdAgentIdDeleteMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    